import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { HitSectionLoading, isBooted, useLoadingLevel } from "@/components/loading";

// Admins AND moderators can enter /admin. Backend endpoints enforce fine-grained
// gating: super_admin (money/config/bans) vs admin_or_moderator (logistics only).
const STAFF_ROLES = new Set(["admin", "moderator"]);

export function ProtectedRoute({ children, requireAdmin = false, requireVerified = false }) {
  const { user, loading, reconnecting } = useAuth();
  const loc = useLocation();
  const level = useLoadingLevel(loading && isBooted());
  if (loading) {
    if (reconnecting) return <div className="p-8 text-neutral-400" data-testid="protected-loading">Reconectando… tu sesión sigue activa.</div>;
    return (
      <div className="max-w-xl mx-auto px-5 py-8 min-h-[70vh]" data-testid="protected-loading">
        {isBooted() && <HitSectionLoading level={level} loading section="profile" />}
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && !STAFF_ROLES.has(user.role)) return <Navigate to="/" replace />;
  if (requireVerified && user.verification_status !== "aprobado" && !STAFF_ROLES.has(user.role)) {
    // Preserve where the user was heading so Verify.jsx can show a contextual CTA
    // (e.g. "Verifica para completar tu compra" / "…para publicar tu carta").
    const from = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/verify?from=${from}`} replace />;
  }
  return children;
}
